/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Picker_Remove_InfantInputs */

const en_guest_picker_remove_infant = /** @type {(inputs: Guest_Picker_Remove_InfantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove infant`)
};

/**
* | output |
* | --- |
* | "Remove infant" |
*
* @param {Guest_Picker_Remove_InfantInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const guest_picker_remove_infant = /** @type {((inputs?: Guest_Picker_Remove_InfantInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Picker_Remove_InfantInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_guest_picker_remove_infant(inputs)
});